import { render, staticRenderFns } from "./TabellaControllo.vue?vue&type=template&id=6640ff9d&scoped=true&"
import script from "./TabellaControllo.vue?vue&type=script&lang=js&"
export * from "./TabellaControllo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6640ff9d",
  null
  
)

export default component.exports